import React, { useState, useContext, Fragment, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ConexContext from "../context/conex/ConexContext";
import { ReactComponent as TrashIcon } from "../assets/img/iconos/acae_trash.svg";
import { ReactComponent as CorreoIcon } from "../assets/img/iconos/acae_mail.svg";
import { ReactComponent as MasIcon } from "../assets/img/iconos/acae_add.svg";
import { ReactComponent as OptionsIcon } from "../assets/img/iconos/acae_options.svg";
import { ReactComponent as ViewIcon } from "../assets/img/iconos/acae_view.svg";
import { ReactComponent as DuplicarIcon } from "../assets/img/iconos/acae_link.svg";
import { ReactComponent as SettingsIcon } from "../assets/img/iconos/acae_settings.svg";
import desc from "../assets/img/desc.svg";
import asc from "../assets/img/asc.svg";
import mas from "../assets/img/iconos/acae_add.svg";
import Swal from 'sweetalert2';
import Paginacion from './comun/Paginacion';
import MenuToggle from "./comun/menuToggle";
import CorreosMod from "./CorreosMod";
import FloatingMenu from './comun/FloatingMenu';

const Correos = ({ setSidebar, Sidebar }) => {
	const { loc, peticion, perfil_admin } = useContext(ConexContext);

	// const [VerMod, setVerMod] = useState(0);
	const [Crear, setCrear] = useState(0);
	const menuRefs = useRef({});
	const [activeMenu, setActiveMenu] = useState(null);
	const [paso, setPaso] = useState(0); //Para los 3 pasos al crear un correo
	const [campos, setCampos] = useState(null); //campos de la vista para los select
	
	// const List = [
	// 	{ id: 1, fecha: "12 JUL 2026", usuarios: 34, titulo: "Convocatoria de examen", estado: "Enviado" },
	// 	{ id: 2, fecha: "05 JUL 2026", usuarios: 12, titulo: "Recordatorio de cuotas", estado: "Borrador" },
	// 	{ id: 3, fecha: "28 JUN 2026", usuarios: 58, titulo: "Newsletter de verano", estado: "Enviado" },
	// ];

	// const [NRes] = useState(List.length);
	// const [NTot] = useState(List.length);
	const [List, setList] = useState([]); // listado
	const [NRes, setNRes] = useState(0); // Nº de registros con filtro
	const [NTot, setNTot] = useState(0); // Nº de registros con filtro
	const [ListParams, setListParams] = useState({
		num: 15,
		orden: "fecha DESC",
		filtro: "",
		ini: 0,
		nomAso: "",
		idAsoc: 0,
		idReg: 0,
	});
	const mostrarCampos = true;
	const formatearFecha = (fechaStr) => {
		if (!fechaStr) return '';
		const date = new Date(fechaStr);
		const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
		// Obtenemos los componentes en UTC para evitar diferencias horarias
		const dia = String(date.getUTCDate()).padStart(2, '0');
		const mes = meses[date.getUTCMonth()];
		const anio = date.getUTCFullYear();
		return `${dia} ${mes} ${anio}`;
	};

	// Función para listar cursos
	const listar = async () => {
		const pet = await peticion(
			"/correos/?" +
				`ini=${ListParams.ini}&` +
				`pag=${ListParams.num}&` +
				`orden=${ListParams.orden}&` +
				`filtro=${ListParams.filtro}`
		);
		if (pet?.estado ?? false)
			// algún error
			return null;
		setList(pet.res);
		setNRes(pet.nRes);
		setNTot(pet.nTot);
	};

	//cambia el orden
	const orden = (campo) => {
		if (ListParams.orden === campo)
			setListParams({ ...ListParams, orden: campo + " DESC" });
		else setListParams({ ...ListParams, orden: campo });
	};

	// Función para duplicar un correo
	const duplicar = async (id) => {
		const pet = await peticion('/correos/duplicar?id=' + id);
		if (pet?.estado ?? false)
			// algún error
			return null;
		Swal.fire({
			title: loc("Correo duplicado."),
			showConfirmButton: false,
			icon: 'success',
			timer: 1500
		});
		setListParams({ ...ListParams });
	};

	function getAsociadoActions(elem) {
		const acciones = [];
		if (mostrarCampos) {
			if (perfil_admin) {
				acciones.push({
					label: loc("Ver correo"),
					icon: <ViewIcon className="icon" />,
					onClick: () => {setPaso(2);setCrear(elem.id);},
				});
				if (elem.estado !== 'Enviado') {
					acciones.push({
						label: loc("Modificar correo"),
						icon: <SettingsIcon className="icon" />,
						onClick: () => {setPaso(0);setCrear(elem.id)},
					});
				}
				acciones.push({
					label: loc("Duplicar correo"),
					icon: <DuplicarIcon className="icon" />,
					onClick: () => 
						Swal.fire({
							title: loc("¿Seguro que quieres duplicar el correo?"),
							showCancelButton: true,
							confirmButtonText: loc("Sí"),
							cancelButtonText: loc("No"),
							icon: "question",
						}).then((result) => {
							if (result.isConfirmed) duplicar(elem.id);
						}),
				});
				if (elem.estado !== 'Enviado') {
					acciones.push({
						label: loc("Eliminar correo"),
						icon: <TrashIcon className="icon" />,
						onClick: () =>
							Swal.fire({
								title: loc("¿Seguro que quieres eliminar el correo antes de enviarlo?"),
								showCancelButton: true,
								confirmButtonText: loc("Sí"),
								cancelButtonText: loc("No"),
								icon: "question",
							}).then((result) => {
								if (result.isConfirmed) borrar(elem.id);
							}),
					});
				}
				
			}
		}
		return acciones;
	}

	const toggleMenu = (id) => {
		setActiveMenu(activeMenu === id ? null : id);
	};

	const accionesPorCorreo = List.reduce((acc, elem) => {
		acc[elem.id] = getAsociadoActions(elem);
		return acc;
	}, {});

	// Borra un registro concreto
	const borrar = async (id) => {
		if (!id) {
			console.error("No se ha proporcionado un ID válido para borrar.");
			return;
		}
		const pet = await peticion('/correos/del', {
			method: 'POST',
			json: { id }
		});
		if (pet?.estado && pet?.estado !== 0) {
			Swal.fire({
				title: loc("El correo no se puede eliminar"),
				text: loc("El correo ya se ha enviado."),
				icon: 'error',
				showConfirmButton: true,
			});
			return;
		}
		Swal.fire({
			title: loc("Correo eliminado."),
			showConfirmButton: false,
			icon: 'success',
			timer: 1500
		});
		setListParams({ ...ListParams });
	};

	//EFFECT
	useEffect(() => {
		listar();
		// eslint-disable-next-line
	}, [ListParams]);

	/**
	 * Se cargan los campos al entrar al modal
	 */
	useEffect(() => {
		async function campos_peticion() {
			const pet = await peticion(
				"/listado/campos_filtrar?vista=asociado",
				{ method: "POST" }
			);
			if (pet?.estado ?? false)
				//algún error
				return null;
			setCampos(pet.res.campos);
		}
		campos_peticion();
	}, [peticion])

	return (
		<>
			<div className="content-wrapper main-section" id="correos">
				<header className="backdrop space-between">
					<div className="flex-row-item">
						<CorreoIcon className="section-icon" alt="Correos" />
						<h1>{loc("Correos")}</h1>
					</div>
					<MenuToggle Sidebar={Sidebar} setSidebar={setSidebar} />
				</header>

				<div className="backdrop content-wrapper">
					<div className="filtering">
						<Paginacion
							nrPag={List.length}
							NRes={NRes}
							NTot={NTot}
							Ini={ListParams.ini}
							setListParams={setListParams}
							Num={ListParams.num}
							Filtro={ListParams.filtro}
						/>
					</div>
					<div className="table-container">
						<table className="table-cursos">
							<thead className="table-headers">
								<tr>
									<th className="tiny-column"></th>
									<th className="large-s-column grow-column">
										<button onClick={() => orden("fecha")}>{loc("Fecha")}</button>
										<ul className="listaordena">
											{ListParams.orden === "fecha" && (
												<li>
													<img src={asc} alt="ordena ascendente" />
												</li>
											)}
											{ListParams.orden === "fecha DESC" && (
												<li>
													<img src={desc} alt="ordena descendente" />
												</li>
											)}
										</ul>
									</th>
									<th className="large-s-column">
										<button onClick={() => orden("usuarios")}>{loc("Usuarios")}</button>
										<ul className="listaordena">
											{ListParams.orden === "usuarios" && (
												<li>
													<img src={asc} alt="ordena ascendente" />
												</li>
											)}
											{ListParams.orden === "usuarios DESC" && (
												<li>
													<img src={desc} alt="ordena descendente" />
												</li>
											)}
										</ul>
									</th>
									<th className="large-s-column grow-column">
										<button onClick={() => orden("titulo")}>{loc("Título")}</button>
										<ul className="listaordena">
											{ListParams.orden === "titulo" && (
												<li>
													<img src={asc} alt="ordena ascendente" />
												</li>
											)}
											{ListParams.orden === "titulo DESC" && (
												<li>
													<img src={desc} alt="ordena descendente" />
												</li>
											)}
										</ul>
									</th>
									<th className="large-column">
										<button onClick={() => orden("estado")}>{loc("Estado")}</button>
										<ul className="listaordena">
											{ListParams.orden === "estado" && (
												<li>
													<img src={asc} alt="ordena ascendente" />
												</li>
											)}
											{ListParams.orden === "estado DESC" && (
												<li>
													<img src={desc} alt="ordena descendente" />
												</li>
											)}
										</ul>
									</th>
								</tr>
							</thead>
							<tbody className="table-results">
								{List.map((elem) => (
									<Fragment key={elem.id}>
										<tr>
											{accionesPorCorreo[elem.id].length > 0 ? (
												<td className="table-button tiny-column">
													<div
														className="menu-wrapper"
														ref={(el) =>
															(menuRefs.current[elem.id] = el)
														}>
														<OptionsIcon
															onClick={() => toggleMenu(elem.id)}
															className="table-button__icon black"
														/>
														{activeMenu === elem.id && (
															<FloatingMenu
																anchorRef={{
																	current: menuRefs.current[elem.id],
																}}
																onClose={() => setActiveMenu(null)}
																id={elem.id}>
																{accionesPorCorreo[elem.id].map((accion, i) =>
																	accion.link ? (
																		<li key={i}>
																			<Link className="no-decoration" to={accion.href}>
																				{accion.icon}
																				<span>{accion.label}</span>
																			</Link>
																		</li>
																	) : (
																		<li key={i} onClick={accion.onClick}>
																			{accion.icon}
																			<span>{accion.label}</span>
																		</li>
																	)
																)}
															</FloatingMenu>
														)}
													</div>
												</td>
											) : (
												<td className="table-button tiny-column">
													<OptionsIcon
														onClick={() => toggleMenu(elem.idCurso)}
														className="table-button__icon black disable-actions"
													/>
												</td>
											)}
											<td className="large-s-column grow-column">{formatearFecha(elem.fecha)}</td>
											<td className="large-s-column">{elem.usuarios}</td>
											<td className="table-button large-s-column grow-column">
												<div className='flex-row-item gap-small flex-grow'>
													<span className="cell-td-button--label grow text-ellipsis">
														{elem.titulo}
													</span>
												</div>
											</td>
											<td
												className={`large-column estado-wrapper ${
													elem.estado === "Enviado" ? "aprobado" : ""
												}`}>
												<div
												className={`estado-container`}>
													{loc(elem.estado)}
												</div>
											</td>
										</tr>
									</Fragment>
								))}
							</tbody>
						</table>
					</div>
					<div>
						<button
							className="button primary"
							onClick={() => setCrear(-1)}>
							{loc("Nuevo correo")}
							<MasIcon src={mas} alt={loc("Más")} />
						</button>
					</div>
				</div>
				<CorreosMod
					show={Crear}
					paso={paso}
					setPaso={setPaso}
					onHide={() => setCrear(0)}
					listar={() => listar()}
					campos={campos}
					setCampos={setCampos}
				/>
			</div>
		</>
	);
};

export default Correos;
